import { deserializeData } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import { NftType } from '@src/constants/bookmark'
import { bookmarkSchema } from '@src/deserialize/yup/bookmark'
import graphql from '@src/graphql/mutation/bookmarkNFT'
import { Bookmark } from '@src/types/bookmark'
import { useCallback, useState } from 'react'

const useBookmarkNFT = (): Hook => {
  const [saveBookmarkNFT, { loading }] = useMutation(graphql)

  const [data, setData] = useState<Response>(null)

  const mutate = useCallback(
    async (request: Request): Promise<Response> => {
      const response = await saveBookmarkNFT({
        variables: {
          input: request
        }
      })

      const result = deserializeData<Bookmark>(response, bookmarkSchema)

      setData(result)

      return result
    },
    [saveBookmarkNFT]
  )

  return {
    mutate,
    data,
    loading
  }
}

type Request = {
  nftType: NftType
  tokenID: string
  isBookmarked: boolean
}

type Response = Bookmark | null

type Hook = {
  mutate: (request: Request) => Promise<Response>
  data: Response
  loading: boolean
}

export default useBookmarkNFT
